import { LogKinds, log } from "@/common/log"
import { addManualInput, changeManualInputs, deleteManualInput, loadSimlation, unloadSimlation, rerunSimSeq, runSimSeq, runSimTopology, updateTopology, updateUnitTTPS, updateBalancePoint } from "@/services/project/simulation.service"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { message } from "antd"



export const runSimSeqThunk = createAsyncThunk('flowsheet/runSimSeqAction', async (params: any) => {
  return await runSimSeq(params)
})

export const reRunSimSeqThunk = createAsyncThunk('flowsheet/rerunSimSeqAction', async (params: any) => {
  return await rerunSimSeq(params)
})

interface RunSimActionParams {
  data: any
  params: {[key: string]: any}
}
export const runSimThunk = createAsyncThunk('flowsheet/runSimAction', async ({data, params}: RunSimActionParams) => {
  return await runSimTopology(data, params)
})

export const loadSimThunk = createAsyncThunk('flowsheet/loadSimAction', async (sId: number) => {
  return await loadSimlation(sId)
})

export const unloadSimThunk = createAsyncThunk('flowsheet/unloadSimAction', async (sId: number) => {
  return await unloadSimlation(sId)
})

interface UpdateTopologyActionParams {
  data: any
  params: {[key: string]: any}
}
export const updateTopologyThunk = createAsyncThunk('flowsheet/updateTopologyAction', async ({data, params}: UpdateTopologyActionParams) => {
  try {
    return await updateTopology(data, params)
  } catch (error: any) {
    message.warning(`updateTopologyThunk faild`)
    log(`[${LogKinds.Flowsheet}]: updateTopologyThunk faild, the message ${error.message}`)
  }
  
})

interface VariableParams {
  data: any
  params: {[key: string]: any}
}
export const addManualInputThunk = createAsyncThunk('flowsheet/addManualInputAction', async ({data, params}: VariableParams) => {
  return await addManualInput(data, params)
})

export const deleteManualInputThunk = createAsyncThunk('flowsheet/deleteManualInputAction', async ({data, params}: VariableParams) => {
  return await deleteManualInput(data, params)
})

export const changeManualInputsThunk = createAsyncThunk('flowsheet/changeManualInputsAction', async ({data, params}: VariableParams) => {
  return await changeManualInputs(data, params)
})

export const updateUnitTTPSThunk = createAsyncThunk('flowsheet/updateUnitTTPSAction', async ({data, params}: VariableParams) => {
  return await updateUnitTTPS(data, params)
})

export const updateBalancePointThunk = createAsyncThunk('flowsheet/updateBalancePointThunk', async ({data, params}: VariableParams) => {
  return await updateBalancePoint(data, params)
})


